import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BaseEntity } from "../base-models/base-entity";
import { ViewChild } from "@angular/core";
import { BaseUpdateComponent } from "./base-update-component";
import { BaseComponent } from './base-component';
import { UserService } from '../base-services/user.service';
import { switchMap } from 'rxjs/operators';

export class BasePageUpdateComponent<T extends BaseEntity> extends BaseComponent{
    constructor(
        protected activatedRoute: ActivatedRoute,
        protected userService: UserService,
        protected router: Router
    ){
        super(activatedRoute, userService);
    }

    @ViewChild('baseUpdate', /* TODO: add static flag */ {static: true}) baseUpdateComponent: BaseUpdateComponent<T>;
    url;

    ngOnInit(){
        super.ngOnInit();

        
        //this.activatedRoute.url
        //.subscribe(url => {
            //this.url = url;
        //})
    }
    
    ngAfterViewInit(){
        this.baseUpdateComponent.ItemSaved
        .subscribe(item => {
            this.onItemSaved(item);
        })
    }
    
    onItemSaved(item){
    }
    
    Save(){
        this.baseUpdateComponent.SaveItem();
    }
    
    OnModelDataLoaded(){
        this.baseUpdateComponent.ModelData = this.modelData;
        
        this.activatedRoute.paramMap
            .subscribe((params: ParamMap) => {
                this.baseUpdateComponent.ID = parseInt(params.get('id'));
            })
        
    }

    RedirectToList(){
        this.router.navigate([this.router.url.substring(0, this.router.url.lastIndexOf('/'))]);
    }
}